<script>
    let { yScale,
        ticks = [-1, -0.5, 0, 0.5, 1, 1.5, 2, 2.5, 3], 
        chartwidth = 400
     } = $props();

    const topTick = $derived(Math.max(...ticks));

    const label = tick => {
        let s = tick > 0 ? `+${tick}` : `${tick}`;
        if (tick === topTick) s += '°C';
        return s;
    };
</script>
<g class="y-axis">
   
    {#each ticks as tick, i}
        {#if tick % 1 === 0}
            <text x=0 y={yScale(tick) - 4} class="tick-text">{label(tick)}</text>
        {/if}
        
        <line class="y-tick" class:zero={tick === 0} class:nino={tick > 0.5}
            x1={0} 
            x2={chartwidth} 
            y1={yScale(tick)} y2={yScale(tick)} 
        >
        </line>
    {/each}
    
</g>
<style lang='scss'>
    .tick-text {
        font-size: 11px;
        fill: #666;
    }
    .y-tick {
        stroke: #999;
        &.zero {
            stroke: #333;
            stroke-width: 1.5;
        }
        &.nino {
            stroke: #ffffff;
        }
    }
</style>